import React from 'react';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { newsData } from '../data/newsData';
import { FaArrowRight } from 'react-icons/fa';
import './Actualites.css';

const Actualites = () => {
  // On fait défiler la page vers le haut au chargement
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Actualités — ATAA REALTY | Expertise Immobilière au Maroc"
        description="Les actualités d'ATAA REALTY : événements, publications et avancées de l'expertise et de l'évaluation immobilière au Maroc."
        canonical="https://ataarealty.com/actualites"
        keywords="actualités immobilières Maroc, expertise immobilière, ATAA Realty"
      />
      <Navbar />

      {/* Header Simple */}
      <div className="page-header">
        <div className="overlay-dark"></div>
        <div className="container">
          <h1>Toutes nos Actualités</h1>
        </div>
      </div>

      <div className="container news-page-container">
        <div className="news-grid">
          {newsData.map((item) => (
            <div className="news-card-full" key={item.id}>
              <div className="news-img-wrap">
                <img src={item.image} alt={item.title} />
                <div className="news-date-badge">
                  <span>{item.date}</span>
                  <small>{item.month}</small>
                </div>
              </div>
              <div className="news-body">
                <h3>{item.title}</h3>
                <p>{item.excerpt}</p>
                <Link to={`/actualites/${item.id}`} className="btn-read">
                  Lire l'article <FaArrowRight />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Actualites;